import { useQuery } from "@tanstack/react-query"
import { useCurrentOrganization } from "@/modules/organizations/hooks/use-organizations"
import { resourceAccessService } from "../infrastructure/resource-access-service"
import { ResourceType } from "../dtos/ResourceAccessDtos"

export function useMyResourceAccess(type: ResourceType, resourceId: string | undefined) {
  const org = useCurrentOrganization()
  const orgId = org?.id ?? ""

  return useQuery({
    queryKey: ["my-resource-access", orgId, type, resourceId],
    queryFn: () => resourceAccessService.getMyAccess(orgId, type, resourceId as string),
    enabled: !!orgId && !!resourceId,
  })
}

/**
 * Read-level UI (disable actions) for a specific record. Defaults open while loading or for an
 * unrestricted/not-yet-fetched record, so nothing is disabled before the access check resolves.
 */
export function useCanEdit(type: ResourceType, resourceId: string | undefined) {
  const { data, isLoading } = useMyResourceAccess(type, resourceId)

  const canEdit = isLoading || !data || data.level === null || data.level === "Edit"
  const isRestricted = data?.isRestricted ?? false
  const level = data?.level ?? null

  return { canEdit, isRestricted, level, isLoading }
}
